export const environment = {
  production: true,
  local: false,
  api: 'https://registry.bc-to.com',
  n8n: 'https://services.betterchains.com',
  services: {
    schedule: 'https://schedule.bc-to.com'
  }
};
